import { NonConformite as NonConformiteGql } from '@graphql/generated';
import { DocumentNonConformite } from '@lib/ged/document-non-conformite.model';
import { NonConformiteCategorieMapper } from './non-conformite-categorie-mapper';

export class NonConformiteMapper {
  public static fromGraphQl(
    input: NonConformiteGql,
    isBackOffice: boolean
  ): DocumentNonConformite {
    return {
      id: input.id,
      categorie: NonConformiteCategorieMapper.fromGraphQl(
        isBackOffice
          ? (input.categorieBackOffice ?? input.categorieBackOfficeId)
          : (input.categorieConsultant ?? input.categorieConsultantId)
      )!,
      commentaire: isBackOffice
        ? input.commentaireBackOffice
        : input.commentaireConsultant,
      opened: isBackOffice ? input.isOpenedBackoffice : input.isOpenedConsultant,
    };
  }
}
